/**
 * Brand palette registry.
 *
 * Maps a brand key (matching the `BRAND_THEME` export in an app's app_constant)
 * to its palette. Adding a future brand = one palette file under this dir + one
 * line here; no changes to themes.js, the providers, or Tailwind.
 */
import { DEFAULT_PALETTE } from '../palette';
import { TRAININGCAMP_PALETTE } from './trainingcamp';

export const BRAND_PALETTES = {
  default: DEFAULT_PALETTE,
  trainingcamp: TRAININGCAMP_PALETTE,
};

/** Resolve a brand key to its palette; unknown/falsy brands fall back to default. */
export function getPalette(brand) {
  return BRAND_PALETTES[brand] || DEFAULT_PALETTE;
}
